import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

// Saves the confirmed residence address and runs CheqM when the backend says it is due (same call as the app).
const triggerCheqmAPI = async ({authToken, subsidiaryId, residenceAddress}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);

    const URL = `${BASE_URL}/${requestSubsidiaryId}/client/user`
    const METHOD = "PATCH"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
    }

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
        body: JSON.stringify({
            residence_address: residenceAddress,
            trigger_cheqm: true
        })
    })

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {triggerCheqmAPI}
